import {
  apiClient,
  type CreateTruckImportJobDto,
  type TruckImportJobExEntity
} from '@/libs/api'

export type CreateTruckImportJobRequest = {
  tenantKey: string
  dto: CreateTruckImportJobDto
}

export const createTruckImportJob = async ({
  tenantKey,
  dto
}: CreateTruckImportJobRequest): Promise<TruckImportJobExEntity> => {
  const { data } = await apiClient._tenant(tenantKey).truck_import_jobs.$post({
    body: dto
  })
  return data
}
